import React, { useState,useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
  Stack,
  Grid,
  CardContent,
  Avatar,
  Switch,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  Box,
  Divider,
  CardActions,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import { Delete, Edit, CheckCircle, Add ,PowerSettingsNew,Public} from "@mui/icons-material";

import ApiService from '../../API/Requesthandler'

function ProxyManagement() {
  const [proxies, setProxies] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    ip: "",
    port: "",
    user: "",
    pass: "",
    type: "http", // Default proxy type
    disabled: false,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkingId, setCheckingId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });


  useEffect(()=>{
    getProxies()
  },[])


  const getProxies = ()=>{
    ApiService.get("/api/proxy/get")
    .then(res =>{
      if (res.success){
        setProxies(res.data)
        setSnackbar({
          open: true,
          message: "Proxies Fetched ...",
          severity: "success",
        });
      }else{
        setSnackbar({
          open: true,
          message: "Failed to fetch proxies...",
          severity: "error",
        });
      }
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddOrUpdateProxy = () => {
    if (!formData.ip || !formData.port) {
      setSnackbar({
        open: true,
        message: "IP and Port are required.",
        severity: "error",
      });
      return;
    }

    if (isEditing) {

      const proxyData = {
        "id" : formData.id,
        "type":formData.type,
        "username":formData.user,
        "password":formData.pass,
        "ip":formData.ip,
        "port":formData.port
      }
      ApiService.put("/api/proxy/update/" + formData.id,proxyData)
      .then(res =>{
        if (res.success){
          getProxies()  
        setSnackbar({
          open: true,
          message: "Proxy updated successfully.",
          severity: "success",
        });
        }
      }).catch(err=>{
        setSnackbar({
          open: true,
          message: "Error updating proxy..",
          severity: "error",
        });
      })
      
    } else {
      // Add new proxy
      const proxyData = {
        "type":formData.type,
        "username":formData.user,
        "password":formData.pass,
        "ip":formData.ip,
        "port":formData.port
      }
      ApiService.post("/api/proxy/add",proxyData)
      .then(res =>{
        getProxies()
        // console.log(res)
        setSnackbar({
          open: true,
          message: "Proxy added successfully.",
          severity: "success",
        });
      }).catch(err=>{
        setSnackbar({
          open: true,
          message: "Failed to add proxy",
          severity: "error",
        });
      })
      
      
    }

    // Reset form and close dialog
    setFormData({ id: null, ip: "", port: "", user: "", pass: "", type: "HTTP", disabled: false });
    setIsEditing(false);
    setOpenDialog(false);
  };

  const handleEditProxy = (proxy) => {
    setFormData(proxy);
    setIsEditing(true);
    setOpenDialog(true);
  };

  const handleDeleteProxy = (id) => {
    
    ApiService.delete("/api/proxy/delete/"+id)
    .then(res =>{
      if (res.success){
        getProxies()
        setSnackbar({
          open: true,
          message: "Proxy deleted successfully.",
          severity: "warning",
        });
      }
    }).catch(err=>{
      setSnackbar({
        open: true,
        message: "Error while delete the proxy...",
        severity: "error",
      });
    })

    
  };

  const handleCheckProxy = (id) => {
    setCheckingId(id);
    setTimeout(() => {
      setProxies((prevProxies) =>
        prevProxies.map((proxy) =>
          proxy.id === id
            ? { ...proxy, status: Math.random() > 0.5 ? "Valid" : "Invalid" }
            : proxy
        )
      );
      setCheckingId(null);
      setSnackbar({
        open: true,
        message: "Proxy check complete.",
        severity: "info",
      });
    }, 1500);
  };

  const handleToggleDisable = (id) => {
    setProxies((prevProxies) =>
      prevProxies.map((proxy) =>
        proxy.id === id ? { ...proxy, disabled: !proxy.disabled } : proxy
      )
    );
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsEditing(false);
    setFormData({ id: null, ip: "", port: "", user: "", pass: "", type: "HTTP", disabled: false });
  };

  return (
    <Container maxWidth="xxl" sx={{ mt: 4, mb: 4 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1">
          Proxy Management
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={handleOpenDialog}
          sx={{ borderRadius: 2 }}
        >
          New Proxy
        </Button>
      </Stack>

      <Grid container spacing={3}>
        {proxies.map((proxy) => (
          <Grid item xs={12} sm={6} md={4} key={proxy.id}>
            <Card 
              sx={{ 
                opacity: proxy.disabled ? 0.6 : 1,
                // transition: 'all 0.2s ease',
                
                // '&:hover': { transform: 'translateY(-2px)' }
              }}
            >
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                  <Avatar sx={{ bgcolor: proxy.status === 'online' ? 'success.main' : 'error.main' }}>
                    <Public fontSize="small" />
                  </Avatar>
                  <Box>
                    <Typography variant="h6">{proxy.ip}:{proxy.port}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {proxy.type.toUpperCase()} Proxy
                    </Typography>
                  </Box>
                </Stack>

                <Divider sx={{ my: 2 }} />

                <Stack spacing={1}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography variant="body2">Username:</Typography>
                    <Typography variant="body2">{proxy.user || 'N/A'}</Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography variant="body2">Password:</Typography>
                    <Typography variant="body2">{proxy.pass ? '•••••' : 'N/A'}</Typography>
                  </Stack>
                </Stack>
              </CardContent>

              <CardActions sx={{ justifyContent: 'space-between', p: 2 }}>
                <Stack direction="row" spacing={1}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleCheckProxy(proxy.id)}
                    disabled={checkingId === proxy.id || proxy.disabled}
                  >
                    {checkingId === proxy.id ? (
                      <CircularProgress size={20} />
                    ) : (
                      <CheckCircle fontSize="small" />
                    )}
                  </IconButton>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => handleEditProxy(proxy)}
                    disabled={proxy.disabled}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleDeleteProxy(proxy.id)}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <Switch
                    size="small"
                    checked={!proxy.disabled}
                    onChange={() => handleToggleDisable(proxy.id)}
                    color="primary"
                  />
                  <PowerSettingsNew 
                    fontSize="small" 
                    color={proxy.disabled ? 'disabled' : 'primary'} 
                  />
                </Stack>
              </CardActions>
            </Card>
          </Grid>
        ))}

        {proxies.length === 0 && (
          <Grid item xs={12}>
            <Card sx={{ textAlign: 'center', p: 4, boxShadow: 0 }}>
              <Typography variant="h6" color="text.secondary">
                No proxies found. Add your first proxy to get started.
              </Typography>
            </Card>
          </Grid>
        )}
      </Grid>

      {/* Add/Edit Dialog (keep existing dialog code exactly as is) */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle sx={{ bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider' }}>
          {isEditing ? "Edit Proxy" : "New Proxy"}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="IP Address"
                name="ip"
                value={formData.ip}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Port"
                name="port"
                value={formData.port}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Username"
                name="user"
                value={formData.user}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Password"
                name="pass"
                value={formData.pass}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                type="password"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Proxy Type</InputLabel>
                <Select
                  name="type"
                  value={formData.type}
                  label="Proxy Type"
                  onChange={handleInputChange}
                >
                  <MenuItem value="http">HTTP</MenuItem>
                  <MenuItem value="https">HTTPS</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ bgcolor: 'background.paper', borderTop: 1, borderColor: 'divider' }}>
          <Button onClick={handleCloseDialog} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleAddOrUpdateProxy} 
            color="primary"
            variant="contained"
          >
            {isEditing ? "Update Proxy" : "Add Proxy"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Keep existing Snackbar code exactly as is */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default ProxyManagement;